import { css } from '@emotion/react';
import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { Box } from '@inflearn/ds-react';
import type { ParseKeys } from 'i18next';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { isNil } from 'lodash-es';
import AppShellLayoutForCSR from '../AppShellLayoutForCSR';
import CustomHead, { type CustomHeadProps } from '../CustomHead';

interface LayoutProps {
  guard?: ({ children }: { children: ReactNode }) => EmotionJSX.Element;
  meta: CustomHeadProps & { title: ParseKeys; description: ParseKeys; siteTitle?: ParseKeys };
  children: ReactNode;
}

/**
 * app-shell ui 만 있고, 별도의 가드가 없는 레이아웃
 */
const Layout = ({ meta, children }: LayoutProps) => {
  const { t } = useTranslation();

  return (
    <>
      {!isNil(meta) && (
        <CustomHead
          {...meta}
          title={t(meta.title)}
          siteTitle={t('인프런')}
          description={t(meta.description)}
          pageCategory={meta.pageCategory ?? t('메타.마이페이지.페이지카테고리')}
        />
      )}
      <AppShellLayoutForCSR
        requiredLogin={false}
        showChanneltalk={false}
        showLanguageSectionButton={true}
      >
        <Box component="main" mih="100vh">
          <div
            css={css([
              {
                display: 'flex',
                flex: '1 1 0',
              },
            ])}
          >
            {children}
          </div>
        </Box>
      </AppShellLayoutForCSR>
    </>
  );
};

export default Layout;
